/**
 * Which EmployeeSalary row the Compensation tab should display.
 *
 * Add Employee step 5 writes the offer salary with effective_from = the
 * employment start date. For a pre-onboarding hire that date is still in
 * the future, so there is no row effective today. Show that upcoming row
 * until the start date. A later raise (a future row while a current row
 * exists) stays off this field and belongs in salary history.
 */

function effectiveKey(salary, field) {
  const raw = salary?.[field];
  if (!raw) return null;
  return String(raw).slice(0, 10);
}

export function localDateKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function selectDisplayedSalary(salaries, todayKey) {
  const rows = (salaries || []).filter((row) => effectiveKey(row, 'payroll_effective_from'));

  const current = rows.filter((row) => {
    const from = effectiveKey(row, 'payroll_effective_from');
    const to = effectiveKey(row, 'payroll_effective_to');
    return from <= todayKey && (!to || to >= todayKey);
  });
  if (current.length > 0) {
    current.sort((a, b) => (
      effectiveKey(b, 'payroll_effective_from').localeCompare(effectiveKey(a, 'payroll_effective_from'))
    ));
    return current[0];
  }

  const upcoming = rows.filter((row) => effectiveKey(row, 'payroll_effective_from') > todayKey);
  if (upcoming.length === 0) return null;
  upcoming.sort((a, b) => (
    effectiveKey(a, 'payroll_effective_from').localeCompare(effectiveKey(b, 'payroll_effective_from'))
  ));
  return upcoming[0];
}
